import { render, staticRenderFns } from "./examineModel.vue?vue&type=template&id=02fafc12&scoped=true"
import script from "./examineModel.vue?vue&type=script&lang=js"
export * from "./examineModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fafc12",
  null
  
)

export default component.exports